module.exports = {"610622001":"大禹街道","610622101":"永坪镇","610622102":"延水关镇","610622103":"文安驿镇","610622104":"杨家圪台镇","610622105":"贾家坪镇","610622107":"关庄镇","610622108":"乾坤湾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610622.json
// module id = 2973
// module chunks = 0